export default __webpack_public_path__ + "static/media/CompoundWords_19.db91ae81.png";